export default class WorkCalendarActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_WORKCALENDAR='GET_HELPER_WORKCALENDAR';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: WorkCalendarActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: WorkCalendarActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: WorkCalendarActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: WorkCalendarActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: WorkCalendarActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: WorkCalendarActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: WorkCalendarActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: WorkCalendarActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: WorkCalendarActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: WorkCalendarActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: WorkCalendarActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: WorkCalendarActions.GET_HELPER_WORKCALENDAR,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: WorkCalendarActions.ERROR_SERVER,
      payload: error
    };
  }
}